'use client'

import type { Route } from 'next'
import { useRouter } from 'next/navigation'
import { Check } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'
import { routes } from '@/config/routes'

export function DoneStep({
  docLabel,
  reference,
  caseId,
}: {
  docLabel: string
  /** The case's reference — same "Reference {ref}" success-row treatment the public onboarding
   * funnel uses (`submission-successful-view.tsx`), so both paths read as the same feature. */
  reference: string
  /** Scopes the "Track status" button to this specific case — see pending-case-card.tsx's
   * identical comment for why this matters once an investor can have more than one case open. */
  caseId?: string
}) {
  const router = useRouter()

  return (
    <Card>
      <CardContent className="flex flex-col items-center gap-3 py-10 text-center">
        <span className="flex size-10 items-center justify-center rounded-full bg-green-600/10 text-green-600">
          <Check className="size-5" />
        </span>
        <p className="text-base font-semibold">Request sent</p>
        <p className="text-muted-foreground max-w-sm text-sm">
          We&apos;ve received your {docLabel} — wait for a telecaller to connect with you at your
          preferred time.
        </p>
        {reference && (
          <div className="bg-muted flex w-full items-center justify-center gap-1.5 rounded-lg px-3.5 py-2.5 text-sm">
            <span className="text-muted-foreground">Reference</span>
            <span className="font-semibold">{reference}</span>
          </div>
        )}
        {/* `/review-status` (`ReviewStatusView`) is the same authenticated status tracker used
            before the dashboard first unlocks, reused here since a fresh self-service case is in
            exactly that same "pending, not published yet" state. */}
        <Button onClick={() => router.push(routes.reviewStatus(caseId) as Route)}>
          Track status
        </Button>
      </CardContent>
    </Card>
  )
}
